import { useSearchParams } from "react-router-dom";
import TemplateEditorComponent from "./template-editor";

const TemplateEditor = () => {
  const [searchParams] = useSearchParams();
  const templateId = searchParams.get('templateId');

  return (
    <div>
      <TemplateEditorComponent templateId={templateId || undefined} />
    </div>
  );
};

export default TemplateEditor;